import MarsImage from './../../hermesComponents/mars-image/index.vue';
export default (Vue) => {
   Vue.component('MarsImage', MarsImage);
}